<span [innerHTML]="space"></span>
<span *ngIf="!removeIcon" [ngSwitch]="open" [class.hide]="!visibilityIcon">
  <span *ngSwitchCase="true" (click)="!manualChange && changeOpenState(false)">
    <ng-container *polymorphOutlet="iconOpen as icon; context: { size: this.size }">
      <prizm-icons-full [name]="$any(icon)" [size]="size"></prizm-icons-full>
    </ng-container>
  </span>
  <span *ngSwitchDefault (click)="!manualChange && changeOpenState(true)">
    <ng-container *polymorphOutlet="iconClose as icon; context: { size: this.size }">
      <prizm-icons-full [name]="$any(icon)" [size]="size"></prizm-icons-full>
    </ng-container>
  </span>
</span>
<ng-content></ng-content>
